import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-placement-listening',
  templateUrl: './add-placement-listening.component.html',
  styleUrls: ['./add-placement-listening.component.scss']
})
export class AddPlacementListeningComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
